import * as firebase from "firebase/app"
import "firebase/storage"
import AppService from "./app-service"
import objectToList from "@/utils/object-to-list"

const path = "certs"

export default class CertService extends AppService {

  constructor() {
    super({ path })
  }

  static get STATUS() {
    return {
      maintenance: { icon: "edit grey icon", description: "Em manutenção" },
      waiting_complement: { icon: "clock orange icon", description: "Aguardando complemento" },
      complement_in_progress: { icon: "sync blue icon", description: "Complemento em andamento" },
      waiting_finishing: { icon: "clock violet icon", description: "Aguardando finalização" },
      finished: { icon: "check circle green icon", description: "Finalizado" },
    }
  }

  static get EVENTS() {
    return {
      create: { icon: "plus blue icon", description: "Criação do laudo" },
      update: { icon: "edit grey icon", description: "Alteração do laudo" },
      finish: { icon: "check circle green icon", description: "Finalização do laudo" },
      image_upload: { icon: "picture purple icon", description: "Envio de imagem" },
      image_delete: { icon: "times red icon", description: "Exclusão de imagem" },
      file_upload: { icon: "file upload blue icon", description: "Envio de anexo" },
      file_delete: { icon: "times red icon", description: "Exclusão de anexo" },
      request_complement: { icon: "tasks orange icon", description: "Solicitação de complemento" },
      start_complement: { icon: "play circle outline teal icon", description: "Início do complemento" },
      finish_complement: { icon: "check double blue icon", description: "Finalização do complemento" },
      delete_complement: { icon: "times red icon", description: "Exclusão da solicitação de complemento" },
      create_fdata: { icon: "plus circle teal icon", description: "Inclusão dos dados financeiros" },
      update_fdata: { icon: "edit outline brown icon", description: "Atualização dos dados financeiros" },
      remove_fdata: { icon: "times circle outline red icon", description: "Exclusão dos dados financeiros" },
      create_anticipation: { icon: "plus square teal icon", description: "Inclusão de antecipação" },
      update_anticipation: { icon: "pen square brown icon", description: "Alteração da antecipação" },
      remove_anticipation: { icon: "times square red icon", description: "Exclusão da antecipação" },
    }
  }

  static get FINANCIAL_STATUS() {
    return {
      uninformed: { id: "uninformed", icon: "circle outline grey icon", description: "Não informado" },
      pending: { id: "pending", icon: "clock outline pink icon", description: "Pagamento pendente" },
      finished: { id: "finished", icon: "check circle green icon", description: "Finalizado" },
    }
  }

  static getStatusList() {    
    return objectToList(CertService.STATUS)
  }

  static getEventsList() {    
    return objectToList(CertService.EVENTS)
  }

  static getFinancialStatusList() {    
    return objectToList(CertService.FINANCIAL_STATUS)
  }

  filter(data) {
    return this.http.post(`${path}/filter`, data)
  }

  requestComplement(id, data) {
    return this.http.post(`${path}/${id}/request-complement`, data)
  }

  startComplement(id) {
    return this.http.post(`${path}/${id}/start-complement`)
  }

  finishComplement(id, comments) {
    return this.http.post(`${path}/${id}/finish-complement`, { comments })
  }

  removeComplement(id) {
    return this.http.delete(`${path}/${id}/remove-complement`)
  }

  finishCert(id) {
    return this.http.post(`${path}/${id}/finish-cert`)
  }

  getImages(certId) {    
    return this.http.get(`${path}/${certId}/images`) 
  }

  getAttachments(certId) {
    return this.http.get(`${path}/${certId}/attachments`)
  }

  removeImage(certId, image) {
    return removeCertFile(certId, image, "images")
  }

  removeAttachment(certId, file) {
    return removeCertFile(certId, file, "attachments")
  }

  async removeAllFiles(certId) {
    
    const images = await this.getImages(certId)
    const attachments = await this.getAttachments(certId)

    for (let image of images) {
      await this.removeImage(certId, image)
    }

    for (let file of attachments) {
      await this.removeAttachment(certId, file)
    }
  }

  createEvent(id, data) {
    return this.http.post(`${path}/${id}/create-event`, data)
  }

  getEvents(id) {
    return this.http.get(`${path}/${id}/events`)
  }

  saveAttachmentComments(certId, comments) {
    return this.http.post("save-cert-attachment-comments", { certId, comments })
  }

  checkFinality(serviceId, finality, animalRegistrationId, certDate, certId) {
    return this.http.post("check-cert-finality", { serviceId, finality, animalRegistrationId, certDate, certId })
  }

  generateCertReceivables(id) {
    return this.http.get(`${path}/${id}/generate-receivables`)
  }

  updateFinancialData(id, receivables) {
    return this.http.put(`${path}/${id}/financial`, { receivables })
  }

  removeFinancialData(id) {
    return this.http.delete(`${path}/${id}/financial`)
  }
  
  findPendingCerts(userId, filter) {

    let path = "/financial-pending-certs"

    if (userId)
      path += `?userId=${userId}`

    return this.http.post(path, { filter })
  }

  updateAnticipations(anticipations) {
    return this.http.put("/update-cert-anticipations", anticipations)
  }
}

async function removeCertFile(certId, file, type) {
  return firebase.storage().ref(`${path}/${certId}/${type}`).child(file.name).delete()
}